var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Items To Pack Summary
 * Compact items list showing products with SKU/UPC, qty to pack, remaining qty.
 * Designed for sidebar display — no images, dense layout.
 */
import React, { useMemo, useCallback } from 'react';
import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { usePackingState, usePackingActions } from '../../../hooks/packing';
import { selectShipmentData } from '../../../redux/packing';
import PackItems from '../../PackItems';
export var ItemsToPackSummary = function () {
    var t = useTranslation().t;
    var _a = usePackingState(), activePackageSeqId = _a.activePackageSeqId, packageMetadataBySeqId = _a.packageMetadataBySeqId, kitComponentProducts = _a.kitComponentProducts, productSkuUpcList = _a.productSkuUpcList, assetReservationList = _a.assetReservationList, assetLotList = _a.assetLotList, facilityLocationList = _a.facilityLocationList, shipmentLocationTypeList = _a.shipmentLocationTypeList, itemAssets = _a.itemAssets;
    var _b = usePackingActions(), handlePackItemBySourceId = _b.handlePackItemBySourceId, handleUnpackItem = _b.handleUnpackItem;
    var shipmentData = useSelector(selectShipmentData);
    // Package sequence IDs for dropdown
    var shipmentPackageSequenceId = useMemo(function () {
        var packageIds = Object.keys(packageMetadataBySeqId);
        var sortedArray = packageIds.slice().sort(function (a, b) { return a - b; });
        var updatedPackageSeqId = sortedArray.map(function (item) { return ({
            key: item,
            value: item
        }); });
        return __spreadArray([{ key: '', value: 'New' }], updatedPackageSeqId, true);
    }, [packageMetadataBySeqId]);
    // Items to pack - aggregate by order item
    var itemsToPackList = useMemo(function () {
        var shipmentItemSourceList = (shipmentData === null || shipmentData === void 0 ? void 0 : shipmentData.shipmentItemSourceList) || [];
        return shipmentItemSourceList.reduce(function (accumulator, item) {
            var _a, _b, _c, _d, _e;
            var product = productSkuUpcList === null || productSkuUpcList === void 0 ? void 0 : productSkuUpcList.find(function (pro) { return pro.productId === (item === null || item === void 0 ? void 0 : item.productId); });
            var newItem = __assign(__assign({}, item), { productName: (_a = product === null || product === void 0 ? void 0 : product.productName) !== null && _a !== void 0 ? _a : '', productSku: (_b = product === null || product === void 0 ? void 0 : product.productSku) !== null && _b !== void 0 ? _b : '', productUpc: (_c = product === null || product === void 0 ? void 0 : product.productUpc) !== null && _c !== void 0 ? _c : '' });
            var existingItemIndex = accumulator.findIndex(function (accItem) { return accItem.orderItemSeqId === item.orderItemSeqId; });
            if (existingItemIndex !== -1) {
                accumulator[existingItemIndex].quantity += (_d = newItem.quantity) !== null && _d !== void 0 ? _d : 0;
                accumulator[existingItemIndex].quantityNotHandled += (_e = newItem.quantityNotHandled) !== null && _e !== void 0 ? _e : 0;
            }
            else {
                accumulator.push(newItem);
            }
            return accumulator;
        }, []);
    }, [shipmentData === null || shipmentData === void 0 ? void 0 : shipmentData.shipmentItemSourceList, productSkuUpcList]);
    // Check if product is serialized
    var isProductSerialized = useCallback(function (productIdToCheck) {
        var _a;
        return (_a = shipmentData === null || shipmentData === void 0 ? void 0 : shipmentData.shipmentItemDetailList) === null || _a === void 0 ? void 0 : _a.some(function (data) { return (data === null || data === void 0 ? void 0 : data.productId) === productIdToCheck && (data === null || data === void 0 ? void 0 : data.serialized) === 'Y'; });
    }, [shipmentData === null || shipmentData === void 0 ? void 0 : shipmentData.shipmentItemDetailList]);
    var onPackUpdate = useCallback(function (quantity, shipmentItemSourceId, packageSeqId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, handlePackItemBySourceId({
                        shipmentItemSourceId: shipmentItemSourceId,
                        quantity: parseInt(quantity) || 1,
                        shipmentPackageSeqId: packageSeqId || undefined
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [handlePackItemBySourceId]);
    var onUnpack = useCallback(function (assetIssuanceId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, handleUnpackItem(assetIssuanceId)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [handleUnpackItem]);
    if (itemsToPackList.length === 0) {
        return _jsx("div", __assign({ className: 'text-center text-gray-400 text-sm py-6' }, { children: t('No items to pack') }), void 0);
    }
    return (_jsx("div", __assign({ className: 'flex flex-col gap-2' }, { children: itemsToPackList.map(function (item, index) {
            var isFullyPacked = item.quantityNotHandled === 0;
            return (_jsxs("div", __assign({ className: "border rounded-lg p-3 transition-colors " + (isFullyPacked ? 'bg-green-50 border-green-200' : 'bg-white border-gray-200') }, { children: [_jsxs("div", __assign({ className: 'flex items-start justify-between gap-2' }, { children: [_jsxs("div", __assign({ className: 'min-w-0 flex-1' }, { children: [_jsx("div", __assign({ className: 'font-semibold text-sm text-gray-800 truncate' }, { children: item.productName }), void 0), _jsxs("div", __assign({ className: 'text-xs text-gray-500 mt-0.5' }, { children: [item.productSku && _jsx("span", { children: item.productSku }, void 0), item.productSku && item.productUpc && _jsx("span", { children: " / " }, void 0), item.productUpc && _jsx("span", { children: item.productUpc }, void 0)] }), void 0)] }), void 0), _jsxs("div", __assign({ className: 'flex items-center gap-1.5 shrink-0' }, { children: [_jsxs("span", __assign({ className: "text-xs font-bold " + (isFullyPacked ? 'text-green-600' : 'text-red-600') }, { children: [item.quantity - item.quantityNotHandled, "/", item.quantity] }), void 0), isProductSerialized(item.productId) && (_jsx(Tag, __assign({ color: 'purple', style: {
                                            margin: 0,
                                            fontSize: 10,
                                            lineHeight: '16px',
                                            padding: '0 4px',
                                            borderRadius: 6
                                        } }, { children: "SN" }), void 0))] }), void 0)] }), void 0), _jsx("div", __assign({ className: 'mt-2' }, { children: _jsx(PackItems, { activeTab: true, item: item, onUnpack: onUnpack, onPackUpdate: onPackUpdate, kitComponentProduct: (kitComponentProducts || []), shipmentPackageSequenceId: shipmentPackageSequenceId, assetReservationList: assetReservationList, assetLotList: assetLotList, facilityLocationList: facilityLocationList, shipmentLocationTypeList: shipmentLocationTypeList, itemAssets: itemAssets, activePackageSeqId: activePackageSeqId, shipmentData: shipmentData === null || shipmentData === void 0 ? void 0 : shipmentData.shipment }, void 0) }), void 0)] }), index));
        }) }), void 0));
};
export default ItemsToPackSummary;
